export default "__VITE_ASSET__DZm0zodg__"